import { useQuery } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

export type ImportJobReport = components["schemas"]["ImportJobReportResponse"];

export const IMPORT_JOB_REPORT_QUERY_KEY = ["import-job-report"] as const;

/**
 * The heavy per-import outcome detail behind GET /imports/jobs/{id}/report
 * (ADR 0034): full withheld-symbol lists + per-row parse errors + blocked flag.
 * Fetched once, on demand, when a background job finishes and the page needs to
 * explain a partial/blocked import. Disabled until a job id is supplied.
 */
export function useImportJobReport(jobId: string | null) {
  const client = useApiClient();
  return useQuery({
    queryKey: [...IMPORT_JOB_REPORT_QUERY_KEY, jobId],
    enabled: jobId !== null,
    queryFn: async () => {
      const { data, error } = await client.GET("/api/imports/jobs/{job_id}/report", {
        params: { path: { job_id: jobId as string } },
      });
      if (error !== undefined) {
        throw new Error("Failed to load import report");
      }
      return data;
    },
  });
}
